import React from 'react';
import styled from 'styled-components';
import ChevronDown from 'icons/src/ChevronDown';

const HasChildrenIcon = ({ className }) => (
  <ChevronDown className={className} />
);

export default styled(HasChildrenIcon)`
  width: .75rem;
  padding-left: .25rem;
  line-height: 0;
  color: #939393;
  display: none;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    display: inline-block;
  }

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
